import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import { getActiveCrawlerSection } from '@hydra/utils/parseRouteParams';

import IssueCounterRow from '@hydra/routes/crawler/components/IssueCounterRow';

export class OnPageCategory extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    params: PropTypes.shape({
      lang: PropTypes.string,
      url: PropTypes.string
    }).isRequired,
    project: PropTypes.shape({
      host: PropTypes.string,
      crawls: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              countTitleIssues: PropTypes.number,
              countDescriptionIssues: PropTypes.number,
              countH1Issues: PropTypes.number,
              countContentIssues: PropTypes.number
            })
          })
        )
      })
    }),
    location: PropTypes.object,
    url: PropTypes.string
  }

  static childContextTypes = {
    location: PropTypes.object
  }

  getChildContext () {
    return {
      location: this.props.location
    };
  }

  getCounters (props) {
    const { lang, url } = props.params;
    const activeSection = getActiveCrawlerSection(props.routes);
    const baseUrl = `/${lang}/crawler/${encodeURIComponent(url)}/on-page`;
    const crawlNode = get(props, 'project.crawls.edges[0].node', {});

    return [
      {
        active: activeSection === 'title-issues',
        amount: crawlNode.countTitleIssues || 0,
        label: <Translate content='crawler_meta_title_issues' />,
        link: `${baseUrl}/title-issues`,
        name: 'title-issues'
      },
      {
        active: activeSection === 'description-issues',
        amount: crawlNode.countDescriptionIssues || 0,
        label: <Translate content='crawler_meta_description_issues' />,
        link: `${baseUrl}/description-issues`,
        name: 'description-issues'
      },
      {
        active: activeSection === 'h1-issues',
        amount: crawlNode.countH1Issues || 0,
        label: <Translate content='crawler_h1_tag_issues' />,
        link: `${baseUrl}/h1-issues`,
        name: 'h1-issues'
      },
      {
        active: activeSection === 'content-issues',
        amount: crawlNode.countContentIssues || 0,
        label: <Translate content='crawler_body_content_issues' />,
        link: `${baseUrl}/content-issues`,
        name: 'content-issues'
      }
    ];
  }

  render () {
    const { children } = this.props;

    return (
      <div className='nr-crawler-on-page-category'>
        <IssueCounterRow counters={this.getCounters(this.props)} />
        {children}
      </div>
    );
  }
}

export default createFragmentContainer(OnPageCategory, {
  project: graphql`
    fragment OnPageCategory_project on Project {
      host
      crawls (offset: 0, limit: 1) {
        edges {
          cursor,
          node {
            countTitleIssues,
            countDescriptionIssues,
            countH1Issues,
            countContentIssues
          }
        }
      }
    }
  `
});
